import { memo, useState } from 'react'
import PropTypes from 'prop-types'
import {
  statusIndicationMemberOptions,
  statusIndicationMemberVariantOptions
} from './constants'
import { Image, Container, ImageContainer } from './styled-components'
import {
  ContactEnclosed,
  MemberEnclosedDefault,
  TeamEnclosedDefault,
  ContactPlain,
  MemberPlainDefault,
  TeamPlainDefault
} from '../icons/users'
import { iconSizeOptions } from '../icons/icons-sizes'
import StatusIndicationStatus from './components/status-indication-status'

const membersIconVariantsEnclosed = {
  [statusIndicationMemberVariantOptions.MEMBER]: MemberEnclosedDefault,
  [statusIndicationMemberVariantOptions.TEAM]: TeamEnclosedDefault,
  [statusIndicationMemberVariantOptions.CONTACT]: ContactEnclosed
}

const membersIconVariants = {
  [statusIndicationMemberVariantOptions.MEMBER]: MemberPlainDefault,
  [statusIndicationMemberVariantOptions.TEAM]: TeamPlainDefault,
  [statusIndicationMemberVariantOptions.CONTACT]: ContactPlain
}

const StatusIndicationComponent = ({
  variant = statusIndicationMemberVariantOptions.MEMBER,
  status = statusIndicationMemberOptions.NO_STATUS,
  iconNotEnclosed = false,
  iconColor,
  image,
  size
}) => {
  const IconComponent = iconNotEnclosed
    ? membersIconVariants[variant]
    : membersIconVariantsEnclosed[variant]
  const [imageIsValid, setImageIsValid] = useState(true)

  if (image && imageIsValid) {
    return (
      <Container>
        <ImageContainer size={size}>
          <Image
            src={image}
            alt=""
            data-inactive={status === statusIndicationMemberOptions.INACTIVE}
            onError={() => setImageIsValid(false)}
          />
        </ImageContainer>
        <StatusIndicationStatus size={size} status={status} />
      </Container>
    )
  }

  return (
    <Container>
      <IconComponent size={size} stroke={iconColor} />
      <StatusIndicationStatus size={size} status={status} />
    </Container>
  )
}

StatusIndicationComponent.propTypes = {
  variant: PropTypes.oneOf(Object.values(statusIndicationMemberVariantOptions)),
  status: PropTypes.oneOf(Object.values(statusIndicationMemberOptions)),
  iconNotEnclosed: PropTypes.bool,
  iconColor: PropTypes.string,
  image: PropTypes.string,
  size: PropTypes.oneOf(Object.values(iconSizeOptions))
}

const MemoizedStatusIndicationComponent = memo(StatusIndicationComponent)
MemoizedStatusIndicationComponent.displayName = 'StatusIndicationComponent'

export default MemoizedStatusIndicationComponent
